import { render } from "./CommentsBox.vue?vue&type=template&id=23659731&scoped=true&ts=true&lang=pug"
import script from "./CommentsBox.vue?vue&type=script&lang=ts"
export * from "./CommentsBox.vue?vue&type=script&lang=ts"

import "./CommentsBox.vue?vue&type=style&index=0&id=23659731&scoped=true&lang=scss"

import exportComponent from "/app/node_modules/@vue/cli-service/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-23659731"]])

export default __exports__